var render = function render(){var _vm=this,_c=_vm._self._c;return _c('payment-order-redirect',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t("entity_added", { entity: _vm.$t("card") })))]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }